// API base URL. Uses the platform-provided REACT_APP_BACKEND_URL in preview,
// but on the custom production domain we call the same origin directly (the
// ingress routes /api to the backend), keeping session cookies first-party
// even when the backend-URL system key cannot be edited.
const ON_CUSTOM_DOMAIN = !/(preview\.emergentagent\.com|emergent\.host|localhost)/.test(
  window.location.hostname,
);

export const API_BASE = `${ON_CUSTOM_DOMAIN ? window.location.origin : process.env.REACT_APP_BACKEND_URL}/api`;
